var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypePauseWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#C2C2C2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_285_476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24Z",
    fill: "#FFC300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5953 8H16.0328C15.4624 8 15 8.46241 15 9.03281V18.5703C15 19.1407 15.4624 19.6031 16.0328 19.6031H16.5953C17.1657 19.6031 17.6281 19.1407 17.6281 18.5703V9.03281C17.6281 8.46241 17.1657 8 16.5953 8Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5953 8H11.0328C10.4624 8 10 8.46241 10 9.03281V18.5703C10 19.1407 10.4624 19.6031 11.0328 19.6031H11.5953C12.1657 19.6031 12.6281 19.1407 12.6281 18.5703V9.03281C12.6281 8.46241 12.1657 8 11.5953 8Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_285_476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypePauseWarning);
export default __webpack_public_path__ + "static/media/Type=PauseWarning.76f7191f678d7b7b4d0766c3af13f7f3.svg";
export { ForwardRef as ReactComponent };